export default __webpack_public_path__ + "static/media/vertex-point.95d4ba8a.svg";